import React from "react";
import "./App.css";
import Servers from "./Components/Servers";

function App() {
  return <Servers />;
}

export default App;
